import { ConnectedUsersPanel } from '@features/realtime/components/ConnectedUsersPanel'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { hasPermission } from '@features/rbac/permissions'

export const Route = createFileRoute('/_layout/admin/connected-users')({
    beforeLoad: async ({ context }) => {
        if (!hasPermission('connected-users.view')) {
            throw redirect({ to: '/unauthorised' })
        }
    },
    component: RouteComponent,
})

function RouteComponent() {
    return <ConnectedUsersPanel />
}
